import CheckIcon from '@mui/icons-material/Check'
import { Divider, Stack, Typography } from '@mui/material'
import { Fragment } from 'react'
import { DefaultDeviceVersion, DeviceVersionLabels, IDevice } from '../../../data/Device'
import EditEntityButton from './EditEntityButton'

const editWidth = '36px'
const labelWidth = '150px'
const orgLabelWidth = '150px'
const versionWidth = '150px'
const isActiveWidth = '60px'

export function Header() {
    return (
        <Fragment>
            <Stack direction='row'>
                <Typography variant='h6' width={editWidth} />
                <Typography variant='h6' width={labelWidth}>Label</Typography>
                <Typography variant='h6' width={orgLabelWidth}>Belongs to</Typography>
                <Typography variant='h6' width={versionWidth}>Version</Typography>
                <Typography variant='h6' width={isActiveWidth}>Active?</Typography>
            </Stack>
            <Divider />
        </Fragment>
    )
}

export function Body(props: { devices: Array<IDevice> }) {
    return (
        <Fragment>
            {props.devices.map(x => {
                const deviceVersion = x.deviceVersion ?? DefaultDeviceVersion

                return (
                    <Stack sx={x.isOverdueForService ? { color: 'red' } : {}} direction='row' key={x.rowKey}>
                        <EditEntityButton width={editWidth} item={x} />
                        <Typography width={labelWidth}>{x.label}</Typography>
                        <Typography width={orgLabelWidth}>{x.orgLabel}</Typography>
                        <Typography width={versionWidth}>{deviceVersion} ({DeviceVersionLabels[deviceVersion]})</Typography>
                        <Stack width={isActiveWidth}>
                            {x.isActive ? <CheckIcon fontSize='small' /> : null}
                        </Stack>
                    </Stack>
                )
            })}
        </Fragment>
    )
}